import styled from 'styled-components'
import { Spacing, Colors, Shadows } from 'cio-design-library/design-tokens'
import { ScrollContainer } from 'builder/components/ScrollContainer'
import Media from 'builder/styles/media'

export const Container = styled(ScrollContainer)`
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: ${Colors.Neutral10};
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${Media.Phone`
    &::-webkit-scrollbar {
      width: 0;
    }
  `}
`

export const EditorPanelSwitcherWrapper = styled.div<{ $isHeaderShadowVisible: boolean }>`
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: ${Colors.White};
  padding: ${Spacing['2XS']} ${Spacing.XS};
  border-radius: 0 0 ${Spacing.S} ${Spacing.S};
  box-shadow: ${({ $isHeaderShadowVisible }) =>
    $isHeaderShadowVisible ? Shadows.lightWithBorderShadowLow : 'none'};
  transition: box-shadow 0.2s ease-out;
`

export const FooterContainer = styled.div<{ $isFooterShadowVisible: boolean }>`
  position: sticky;
  bottom: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background-color: ${Colors.White};
  border-radius: ${Spacing.S} ${Spacing.S} 0 0;
  box-shadow: ${({ $isFooterShadowVisible }) =>
    $isFooterShadowVisible ? Shadows.lightWithBorderShadowMid : 'none'};
  transition: box-shadow 0.2s ease-out;
  padding: ${Spacing.XS};
`
